import { mapObject, pick } from 'underscore';

import { staticTemplateProperties } from '@bingads-webui-campaign-react/ad-placement-templates';

import { getLocalizedText, getPreviewTexts } from '../common/index';

const defaultPreviewTextKeys = {
  longHeadline: _TL_('Freshly Delivered Flowers | Save 10% | Free Delivery'),
  description: _TL_('Sustainably Grown Flowers On Sale and Ready To Ship. Order Now.'),
};

export const transformToTemplateData = ({
  adData,
  decoratorsData,
  template,
  i18n,
}) => {
  const localizedText = getLocalizedText(template, i18n);
  const carryOverProperties = pick(template, staticTemplateProperties);
  const {
    previewSettings,
    styleOverrides,
  } = template;

  const defaultPreviewTexts = {
    ...mapObject(defaultPreviewTextKeys, stringKey => i18n.getString(stringKey)),
  };
  const previewTexts = getPreviewTexts({
    adData,
    skipUrlValidation: true,
    defaultPreviewTexts,
  });

  return {
    i18n,
    previewTexts,
    styleOverrides,
    decoratorsData,
    ...carryOverProperties,
    ...localizedText,
    ...previewSettings,
  };
};
